export const OPEN_RULES_DRAWER = 'OPEN_RULES_DRAWER';
export const CLOSE_RULES_DRAWER = 'CLOSE_RULES_DRAWER';

const open = team => ({
  type: OPEN_RULES_DRAWER,
  payload: team,
});

const close = () => ({
  type: CLOSE_RULES_DRAWER,
});

export default { open, close };
